<template lang="pug">
  form(v-if="pfParams", :action="`${payfast_url}`", ref='payfastForm')
    input(v-for="(value, name, index) in pfParams", :key="index", :name="name", type='hidden', :value="value")
</template>

<script>
// import Vue from 'vue';
import standardMix from '@/mixins/standardMix';
import md5 from 'md5';

export default {
  name: 'PayfastForm',
  components: {},
  mixins: [standardMix],
  // props: ['paymentParams'],
  data() {
    return {
      pfParams: null,
    };
  },
  computed: {},
  methods: {
    makePayment(paymentParams) {
      // eslint-disable-next-line camelcase
      const { amount, m_payment_id } = paymentParams;
      this.pfParams = {
        merchant_id: process.env.VUE_APP_MERCHANT_ID,
        merchant_key: process.env.VUE_APP_MERCHANT_KEY,
        return_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-ok`,
        cancel_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-not-ok`,
        notify_url: `${process.env.ROOT_API}/payment/payfast/itn`,
        name_first: this.account.user.firstname,
        name_last: this.account.user.lastname,
        email_address: this.account.user.email,
        cell_number: this.account.user.phone,
        m_payment_id,
        amount,
        // subscription_type: this.isRental ? 2 : 0,
        // recurring_amount: this.isRental ? this.rental.price_rental : 0,
        // frequency: 3,
        // cycles: 0,
        item_name: 'Wall Art Order',
        email_confirmation: '1',
        confirmation_address: 'dehanlouw@icloud.com',
        // subscription_type,
        signature: '',
      };
      // Add signature
      const sig = this.makeSignature(this.pfParams);
      this.pfParams.signature = sig;
      // this.addSignature();
      // setTimeout to put this into event queue after component render
      setTimeout(() => {
        this.$refs.payfastForm.submit();
      }, 10);
    },
    // addSignature() {
    //   // const paySlice = { ...payment };
    //   // console.log(paySlice);
    //   // Create the paramter string
    //   let paramString = '';
    //   // eslint-disable-next-line no-restricted-syntax
    //   for (const [key, value] of Object.entries(this.pfParams)) {
    //     paramString += `${key}=${encodeURIComponent(value)}&`;
    //   }
    //   paramString = paramString.slice(0, -1);
    //   // Add signature
    //   console.log('Adding signature for:');
    //   console.log(this.pfParams);
    //   const sig = md5(paramString);
    //   this.pfParams.signature = sig;
    // },
    makeSignature(payment) {
      const paySlice = { ...payment };
      console.log({ paySlice });
      // Create the param string
      let paramString = '';
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(payment)) {
        paramString += `${key}=${encodeURIComponent(value)}&`;
      }
      paramString = paramString.slice(0, -1);
      console.log(`Paramstring: ${sig}`);

      // Add signature
      const sig = md5(paramString);
      return sig;
    },
  },
  async created() {
    // Setup PayFast parameters
    this.payfast_url = process.env.VUE_APP_PAYFAST_URL;
    // this.pfParams = {
    //   merchant_id: process.env.VUE_APP_MERCHANT_ID,
    //   merchant_key: process.env.VUE_APP_MERCHANT_KEY,
    //   return_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-ok`,
    //   cancel_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-not-ok`,
    //   notify_url: `${process.env.ROOT_API}/payment/payfast/itn`,
    //   name_first: this.account.user.firstname,
    //   name_last: this.account.user.lastname,
    //   email_address: this.account.user.email,
    //   cell_number: this.account.user.phone,
    //   item_name: 'Wall Art Order',
    //   email_confirmation: '1',
    //   confirmation_address: 'dehan@wallcollective.co',
    //   // signature: '',
    // };

    // this.pfParams = {
    //   merchant_id: process.env.VUE_APP_MERCHANT_ID,
    //   merchant_key: process.env.VUE_APP_MERCHANT_KEY,
    //   return_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-ok`,
    //   cancel_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-not-ok`,
    //   notify_url: `${process.env.ROOT_API}/payment/payfast/itn`,
    //   name_first: this.account.user.firstname,
    //   name_last: this.account.user.lastname,
    //   email_address: this.account.user.email,
    //   cell_number: this.account.user.phone,
    //   m_payment_id: '',
    //   amount: 0,
    //   // subscription_type: this.isRental ? 2 : 0,
    //   // recurring_amount: this.isRental ? this.rental.price_rental : 0,
    //   // frequency: 3,
    //   // cycles: 0,
    //   item_name: 'Wall Art Order',
    //   email_confirmation: '1',
    //   confirmation_address: 'dehanlouw@icloud.com',
    //   signature: '',
    // };
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/PayfastForm.vue